var app = angular.module('leonardo');

var BorderColorDirective = function(ConfigThemeService) {
  return {
    restrict: 'A',
     scope: {
      opacity: '='
    },
    link: function (scope, element, attrs) {
      scope.setColor = function () {
        if (!isNull(scope.opacity)) {
          scope.color = ConfigThemeService.getColor(attrs.borderColor, scope.opacity);
        }
        else {
          scope.color = ConfigThemeService.config.theme_config[attrs.borderColor] + '';
        }
        element.css('border-color', scope.color);
      };

      scope.setColor();

      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });

      scope.$watch(function() {
        return element.attr('border-color');
      }, function(newValue, oldValue){
        if ((newValue !== oldValue) && newValue) {
          scope.setColor();
        }
      });
    }
  };
};

app.directive('borderColor', ['ConfigThemeService', BorderColorDirective]);
